import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { to } from '@tencent/wphk-base-utils';
import { CouponGuide } from '@tencent/wphk-components-coupon-guide';
import { isReturningHKUser } from '@/api';
import { MAINLAND_COUPON_GUIDE_POSID } from '@/config/module-config/mainland';
import { DP_PAGE } from '@/config/dp';


export default /*#__PURE__*/_defineComponent({
  __name: 'coupon-guide',
  setup(__props) {

const isNewUser = ref(false);
onMounted(async () => {
  const [err, result] = await to(isReturningHKUser());
  if (err || !result) return;
  isNewUser.value = true;
});

return { __sfc: true,isNewUser, CouponGuide, MAINLAND_COUPON_GUIDE_POSID, DP_PAGE }
}

})